// extracted by mini-css-extract-plugin
module.exports = {"privacy":"Privacy_privacy_21rf4","privacy_section":"Privacy_privacy_section_9_is3"};